import React from 'react';

export default () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.28123 15H15.7187C16.3875 15 16.7219 14.1906 16.25 13.7188L12.5312 10C12.2375 9.70625 11.7625 9.70625 11.4719 10L7.74998 13.7188C7.2781 14.1906 7.61248 15 8.28123 15Z'
      fill='#29B51C'
    />
  </svg>
);
